export function activeLayers<K extends string, T>(item: [K, T])
{
    const config = useRuntimeConfig();
    const enabledLayers = config.public.layers.split(',').map(layer => layer.trim()) || [];
    const [key] = item;

    if (key.startsWith('/'))
        return true;

    for (const layer of enabledLayers)
    {
        if (key.startsWith(`../layers/${layer}`))
            return true;
    }

    return false;
};
